<template>
  <!-- 基本資料頁 -->


    

  <div class="list" style="margin-top:-30px">

<p class="segmented segmented-round">
      <button :class="{'button':true,'button-round':true,'button-outline':true,'button-active':progressActive}" v-on:click="changeButton('progress')">基本資料</button>
      <button :class="{'button':true,'button-round':true,'button-outline':true,'button-active':approvedActive}" v-on:click="changeButton('approved')" style="display:none">輔導面向</button>
    </p>

    <ul v-if="progressActive">
      <li class="input-hint" >１.. 您的姓名</li>
      <li class="item-content item-input">
        <div class="item-inner">
          <div class="item-input-wrap">
            <input class="resizable filled" v-model="studentName" placeholder="您的回答" type="text">
              
            </input>
          </div>
        </div>
      </li>

      <li class="input-hint" >２. 您的系級</li>
      <li class="item-content item-input">
        <div class="item-inner">
          <div class="item-input-wrap">
            <input class="resizable filled"  v-model="studentDepartment" placeholder="您的回答" type="text" readonly>
              
            </input>
          </div>
        </div>
      </li>
      <li class="input-hint" >３. 您的學號</li>
      <li class="item-content item-input">
        <div class="item-inner">
          <div class="item-input-wrap">
            <input class="resizable filled"  v-model="studentId" placeholder="您的回答" type="text" readonly>
              
            </input>
          </div>
        </div>
      </li>

      <li class="input-hint" style="display:none" >4. 身分</li>
      <li class="item-content item-input" style="display:none">
        <div class="item-inner">
          <div class="item-input-wrap">
            <input class="resizable filled" readonly v-model="isstudentweek" placeholder="" type="text" readonly>
              
            </input>
          </div>
        </div>
      </li>



      <li class="input-hint" >4. 身分證號碼</li>
      <li class="item-content item-input">
        <div class="item-inner">
          <div class="item-input-wrap">
            <input class="resizable filled"  v-model="studentIdno" placeholder="您的回答" type="text">
              
            </input>
          </div>
        </div>
      </li>


      <li class="input-hint" >5. 聯絡電話</li>
      <li class="item-content item-input">
        <div class="item-inner">
          <div class="item-input-wrap">
            <input class="resizable filled"  v-model="studentPhone" placeholder="您的回答" type="number">
              
            </input>
          </div>
        </div>
      </li>

      <li class="input-hint" >6. 電子郵件地址</li>
      <li class="item-content item-input">
        <div class="item-inner">
          <div class="item-input-wrap">
            <input class="resizable filled"  v-model="studentEmail" placeholder="您的回答" type="text">
              
            </input>
          </div>
        </div>
      </li>


    


      <li class="input-hint" >7. 匯款單位</li>
      <li class="item-content item-input">
        <div class="item-inner">
          <div class="item-input-wrap" style="display:none">
            
            <label @click="optionChange('70012')"><input class="resizable filled" name="a" v-model="bankType" value="POST" type="radio" />郵局</label>
            <label @click="optionChange('')"><input class="resizable filled" name="a" v-model="bankType" value="BANK" type="radio" @click="optionChange('')"/>銀行</label><br>
          </div>

          <div class="item-input-wrap">
            <select name="時數" v-model="selectedBank" @change="bankchange()">
              <option value="">===請選擇===</option>
              <option value="001">001 中央信託</option>
<option value="003">003 交通銀行</option>
<option value="004">004 台灣銀行</option>
<option value="005">005 土地銀行</option>
<option value="006">006 合庫商銀</option>
<option value="007">007 第一銀行</option>
<option value="008">008 華南銀行</option>
<option value="009">009 彰化銀行</option>
<option value="010">010 華僑銀行</option>
<option value="011">011 上海銀行</option>
<option value="012">012 台北富邦</option>
<option value="013">013 國泰世華</option>
<option value="016">016 高雄銀行</option>
<option value="017">017 兆豐商銀</option>
<option value="018">018 農業金庫</option>
<option value="021">021 花旗銀行</option>
<option value="024">024 運通銀行</option>
<option value="025">025 首都銀行</option>
<option value="039">039 荷蘭銀行</option>
<option value="040">040 中華開發</option>
<option value="050">050 臺灣企銀</option>
<option value="051">051 台北商銀</option>
<option value="052">052 新竹商銀</option>
<option value="053">053 台中商銀</option>
<option value="054">054 京城商銀</option>
<option value="056">056 花蓮企銀</option>
<option value="057">057 台東企銀</option>
<option value="075">075 東亞銀行</option>
<option value="081">081 匯豐銀行</option>
<option value="083">083 渣打銀行</option>
<option value="087">087 標旗銀行</option>
<option value="101">101 台北一信</option>
<option value="102">102 華泰銀行</option>
<option value="103">103 臺灣新光商銀</option>
<option value="104">104 台北五信</option>
<option value="106">106 台北九信</option>
<option value="108">108 陽信銀行</option>
<option value="114">114 基隆一信</option>
<option value="115">115 基隆二信</option>
<option value="118">118 板信銀行</option>
<option value="119">119 淡水一信</option>
<option value="120">120 淡水信合社</option>
<option value="124">124 宜蘭信合社</option>
<option value="127">127 桃園信合社</option>
<option value="130">130 新竹一信</option>
<option value="132">132 新竹三信</option>
<option value="139">139 竹南信合社</option>
<option value="146">146 台中二信</option>
<option value="147">147 三信銀行</option>
<option value="151">151 第七商銀</option>
<option value="158">158 彰化一信</option>
<option value="161">161 彰化五信</option>
<option value="162">162 彰化六信</option>
<option value="163">163 彰化十信</option>
<option value="165">165 鹿港信合社</option>
<option value="178">178 嘉義三信</option>
<option value="179">179 嘉義四信</option>
<option value="188">188 台南三信</option>
<option value="203">203 高雄二信</option>
<option value="204">204 高雄三信</option>
<option value="215">215 花蓮一信</option>
<option value="216">216 花蓮二信</option>
<option value="222">222 澎湖一信</option>
<option value="223">223 澎湖二信</option>
<option value="224">224 金門信合社</option>
<option value="512">512 雲林漁會</option>
<option value="515">515 嘉義漁會</option>
<option value="517">517 南市區漁會</option>
<option value="518">518 南縣漁會</option>
<option value="521">521 彌陀漁會</option>
<option value="521">521 永安漁會</option>
<option value="521">521 興達港漁會</option>
<option value="521">521 林園區漁會</option>
<option value="523">523 東港漁會</option>
<option value="523">523 琉球區漁會</option>
<option value="523">523 林邊區漁會</option>
<option value="524">524 新港漁會</option>
<option value="525">525 澎湖區漁會</option>
<option value="605">605 高雄市農會</option>
<option value="613">613 名間農會</option>
<option value="614">614 永靖農會</option>
<option value="614">614 秀水農會</option>
<option value="614">614 二林農會</option>
<option value="614">614 埔心農會</option>
<option value="614">614 員林農會</option>
<option value="614">614 埤頭鄉農會</option>
<option value="614">614 竹塘農會</option>
<option value="616">616 四湖農會</option>
<option value="616">616 大埤農會</option>
<option value="616">616 二崙農會</option>
<option value="616">616 口湖農會</option>
<option value="616">616 莿桐農會</option>
<option value="616">616 褒忠農會</option>
<option value="616">616 斗六農會</option>
<option value="616">616 西螺農會</option>
<option value="616">616 虎尾農會</option>
<option value="616">616 崙背鄉農會</option>
<option value="616">616 台西農會</option>
<option value="616">616 古坑農會</option>
<option value="616">616 斗南農會</option>
<option value="617">617 六腳農會</option>
<option value="617">617 朴子農會</option>
<option value="617">617 太保農會</option>
<option value="617">617 鹿草農會</option>
<option value="617">617 大埔農會</option>
<option value="617">617 水上鄉農會</option>
<option value="617">617 民雄農會</option>
<option value="617">617 溪口農會</option>
<option value="617">617 竹崎農會</option>
<option value="617">617 布袋鎮農會</option>
<option value="617">617 東石農會</option>
<option value="617">617 新港農會</option>
<option value="617">617 大林農會</option>
<option value="617">617 梅山農會</option>
<option value="617">617 嘉義農會</option>
<option value="617">617 番路農會</option>
<option value="617">617 義竹農會</option>
<option value="618">618 歸仁農會</option>
<option value="618">618 六甲農會</option>
<option value="618">618 善化鎮農會</option>
<option value="618">618 西港農會</option>
<option value="618">618 北門農會</option>
<option value="618">618 佳里鎮農會</option>
<option value="618">618 永康農會</option>
<option value="618">618 鹽水農會</option>
<option value="618">618 新營農會</option>
<option value="618">618 將軍農會</option>
<option value="618">618 玉井農會</option>
<option value="619">619 鳳山市農會</option>
<option value="619">619 阿蓮農會</option>
<option value="619">619 仁武農會</option>
<option value="619">619 大社農會</option>
<option value="619">619 田寮農會</option>
<option value="619">619 鳥松農會</option>
<option value="619">619 梓官農會</option>
<option value="619">619 林園農會</option>
<option value="619">619 大寮農會</option>
<option value="619">619 橋頭農會</option>
<option value="619">619 燕巢農會</option>
<option value="619">619 永安農會</option>
<option value="619">619 湖內農會</option>
<option value="619">619 路竹農會</option>
<option value="619">619 彌陀農會</option>
<option value="619">619 甲仙農會</option>
<option value="619">619 杉林農會</option>
<option value="619">619 旗山農會</option>
<option value="619">619 岡山農會</option>
<option value="619">619 茄萣農會</option>
<option value="619">619 美濃農會</option>
<option value="620">620 恒春農會</option>
<option value="620">620 滿州農會</option>
<option value="620">620 新埤農會</option>
<option value="620">620 枋山農會</option>
<option value="620">620 東港鎮農會</option>
<option value="620">620 里港鄉農會</option>
<option value="620">620 南州農會</option>
<option value="620">620 崁頂鄉農會</option>
<option value="620">620 麟洛農會</option>
<option value="620">620 琉球農會</option>
<option value="620">620 九如鄉農會</option>
<option value="621">621 富里鄉農會</option>
<option value="621">621 壽豐農會</option>
<option value="621">621 吉安農會</option>
<option value="621">621 新秀農會</option>
<option value="622">622 太麻里農會</option>
<option value="622">622 東河農會</option>
<option value="622">622 台東農會</option>
<option value="622">622 成功農會</option>
<option value="622">622 關山農會</option>
<option value="622">622 池上農會</option>
<option value="622">622 鹿野農會</option>
<option value="622">622 長濱農會</option>
<option value="624">624 澎湖農會</option>
<option value="625">625 台中市農會</option>
<option value="627">627 連江縣農會</option>
<option value="700">700 中華郵政</option>
<option value="803">803 聯邦銀行</option>
<option value="804">804 中華銀行</option>
<option value="805">805 遠東銀行</option>
<option value="806">806 復華銀行</option>
<option value="807">807 建華銀行</option>
<option value="808">808 玉山銀行</option>
<option value="809">809 萬泰銀行</option>
<option value="810">810 寶華銀行</option>
<option value="812">812 台新銀行</option>
<option value="814">814 大眾銀行</option>
<option value="815">815 日盛銀行</option>
<option value="816">816 安泰銀行</option>
<option value="822">822 中國信託</option>
<option value="825">825 慶豐銀行</option>
            </select>
          </div>

        </div>
      </li>

      <li class="input-hint" >8. 七碼通儲金融代號</li>
      <li class="item-content item-input">
        <div class="item-inner">
          <div class="item-input-wrap">
            <input class="resizable filled" v-model="bankCode" placeholder="您的回答" type="text">
              
            </input>
          </div>
        </div>
      </li>

      <li class="input-hint" >9. 帳號</li>
      <li class="item-content item-input">
        <div class="item-inner">
          <div class="item-input-wrap">
            <input class="resizable filled"  v-model="bankNumber" placeholder="您的回答" type="text">
              
            </input>
          </div>
        </div>
      </li>

      
      <li class="input-hint" style="display:none">11. LINE ID</li>
      <li class="item-content item-input"  style="display:none">
        <div class="item-inner">
          <div class="item-input-wrap">
            <input class="resizable filled"  v-model="studentLineId" placeholder="您的回答" type="text">
              
            </input>
          </div>
        </div>
      </li>

    
     
    </ul>



    <ul v-if="approvedActive">
     

    
      <li class="input-hint" >A. 參與勵學</li>
      <li class="item-content item-input">
        <div class="item-inner">
          <div class="item-input-wrap">
            <label><input class="resizable filled" v-model="studentJoinType"  value="1" type="checkbox"/>職涯輔導</label> 
            <f7-link @click="checkHref('http://csld.thu.edu.tw/web/page/page.php?scid=67&sid=67/')">
              <div>詳細資訊</div>
            </f7-link><br>
            <label><input class="resizable filled" v-model="studentJoinType"  value="2" type="checkbox"/>服務實踐</label>
            <f7-link @click="checkHref('http://csld.thu.edu.tw/web/page/page.php?scid=66&sid=65/')">
              <div>詳細資訊</div>
            </f7-link><br>

            <label><input class="resizable filled" v-model="studentJoinType"  value="3" type="checkbox"/>領袖培力</label>
            <f7-link @click="checkHref('http://csld.thu.edu.tw/web/page/page.php?scid=65&sid=64/')">
              <div>詳細資訊</div>
            </f7-link><br>

            <label><input class="resizable filled" v-model="studentJoinType"  value="4" type="checkbox"/>課業輔導</label>
            <f7-link @click="checkHref('http://csld.thu.edu.tw/web/page/page.php?scid=68&sid=68/')">
              <div>詳細資訊</div>
            </f7-link><br>
            <label><input class="resizable filled" v-model="studentJoinType"  value="5" type="checkbox"/>學習型實習</label>      
            <f7-link @click="checkHref('http://csld.thu.edu.tw/web/page/page.php?scid=69&sid=69/')">
              <div>詳細資訊</div>
            </f7-link><br>      
          </div>
        </div>
      </li>

    
    <li class="input-hint" ><label style="color:red">*</label>B. 請選擇<label style="color:red">兩項</label>則本學年欲參與之社群專屬課程</li>
  
      <li class="item-content item-input">
        <div class="item-inner">
          <div class="item-input-wrap">
            <label><input class="resizable filled" v-model="studentGroupType"  value="10202" type="checkbox"/>L1-Alpha Leader</label><br>
            <label><input class="resizable filled" v-model="studentGroupType"  value="10203" type="checkbox"/>L1-棟長</label><br>
            <label><input class="resizable filled" v-model="studentGroupType"  value="10204" type="checkbox"/>L1-勞作小組長</label><br>
            <label><input class="resizable filled" v-model="studentGroupType"  value="10205" type="checkbox"/>L1-勞教家族幹部</label><br>
            <label><input class="resizable filled" v-model="studentGroupType"  value="10206" type="checkbox"/>L1-社團幹部</label>  <br>
            <label><input class="resizable filled" v-model="studentGroupType"  value="10215" type="checkbox"/>L1-住宿主題村幹部</label> <br>    

            <label><input class="resizable filled" v-model="studentGroupType"  value="10305" type="checkbox"/>L2-S-ALPHA</label> <br>  
            <label><input class="resizable filled" v-model="studentGroupType"  value="10306" type="checkbox"/>L2-區域棟長</label> <br>  
            <label><input class="resizable filled" v-model="studentGroupType"  value="10307" type="checkbox"/>L2-勞教家族大隊長</label> <br>  
            <label><input class="resizable filled" v-model="studentGroupType"  value="10308" type="checkbox"/>L2-基本勞作區隊長</label> <br>         
          </div>
        </div>
      </li>


     
    </ul>



    <div class="block" @click="okmodify">
      <a href="" class="log-out-button">
        <i class="material-icons">modify</i>
        <span>確定儲存</span>
      </a>
    </div>


  </div>


</template>
<style>
.input-hint {
  margin-left:20px;
}
input[type=checkbox] {
  margin-left:5px;
  margin-right:10px;
  margin-bottom:10px;
}
input[type=radio] {
  margin-left:5px;
  margin-right:10px;
  margin-bottom:10px;
}
</style>
<script>
import Service from "../../service";
import axios from '../../js/axiosModule';

export default {
  components: {},
  data() {
    return {
      bankCode: '',
      bankNumber: '',
      progressActive:true,
      approvedActive:false,
      selectedBank: '',
      studentInfo: '',
      studentIdno: '',
      studentEmail: '',
      studentLineId: '',
      studentDepartment: '',
      studentId: '',
      isstudentweek: '',
      studentPhone: '',
      studentName: '',
      studentJoinType: [], 
      studentGroupType: [], 
      bankType: ''
    };
  },

  created: function() {
    

    
    this.init();

  },


  methods: {
    optionChange:function(code) {
      this.bankCode = code;
    },
    checkHref: function (linkText) {
          window.open(linkText);
      },
    changeButton : function(objType) {

      let self = this;
      if( objType === "progress" ) {
        self.progressActive = true;
     
        self.approvedActive = false;
      } else if ( objType === "approved" ) {
        self.progressActive = false;

        self.approvedActive = true;
      }
    },
    bankchange:function() {
      let self = this;
      if(self.selectedBank == "700") {
        self.bankCode = "7000021";
        this.bankType = "POST";
      }else {
        this.bankType = "BANK";
      }
    },
    init: function() {
      let self = this;
  
      var params = {};
      params.studentId = this.$store.state.userInfo.studentNo;


      this.studentDepartment = this.$store.state.userInfo.department;
      this.studentEmail = this.$store.state.userInfo.email;
      this.studentId = this.$store.state.userInfo.studentNo;
        

      axios.axiosTokenPost(self.$app.axiosUrl+"/api/Student/GetStudentDesc",params).then((response)=> { 
             
        if(response.data.status == 200) {                
          
            var respData = response.data.data;

            if (respData == null) {
              this.studentJoinType = [];      
              this.studentGroupType = [];           
            }else {
             
              this.bankCode = respData.bankCode;
              this.bankNumber = respData.bankNumber;
              this.studentInfo = respData.studentInfo;
              this.studentIdno = respData.studentIdno;                              
              this.studentPhone = respData.studentPhone;
              this.selectedBank = respData.memo;
              this.studentName = respData.studentName;
              this.studentJoinType = respData.studentJoinType.split(',');
              this.studentGroupType = respData.studentGroupType.split(',');
              this.studentLineId = respData.createdBy;
              if (respData.studentType == 1) {
             
                this.isstudentweek = "勵學生";
              }else {
                
                this.isstudentweek = "一般生";
              }
              this.bankType = respData.bankType;
            }
            

        } else {
          alert("fail!");
        }
      }).catch(err=>function() {
        alert("fail!");
      });
    },
    okmodify : function() {   

         
        let self = this;

        var params = {};
        params.studentId = this.$store.state.userInfo.studentNo;
        params.bankCode = self.bankCode;
        params.bankNumber = self.bankNumber;
        params.studentInfo = self.studentInfo;
        params.studentIdno = self.studentIdno;
        params.studentEmail = self.studentEmail;
        params.studentDepartment = self.studentDepartment;
        params.studentPhone = self.studentPhone;
        params.studentName = self.studentName;        
        params.memo = self.selectedBank
        params.bankType = self.bankType;    
        params.createdBy = self.studentLineId;    
        params.studentJoinType = self.studentJoinType+'';
     
        params.studentGroupType = self.studentGroupType+'';

        //手機需要為10位阿拉不數字
        if(self.studentPhone.length == 0  || self.studentPhone.length == 10) {
          
        }else {
          alert("手機需要為10位阿拉伯數字");
          return false;
        }

     

        if(self.studentEmail.length > 0  ) {
          if(self.studentEmail.indexOf("@") < 0  ) {
              alert("email格式錯誤");
              return false;
            }
        }

        if(self.studentIdno.length > 0  ) {
          if(checkTwID(self.studentIdno) == false  ) {
              alert("身份證格式錯誤");
              return false;
            }
        }

        if(self.studentGroupType.length > 3) {
          alert("社群課程不能選超過兩個項目");
        }else {
      
          axios.axiosTokenPost(self.$app.axiosUrl+"/api/Student/SetStudentDesc",params).then((response)=> {
          if(response.data.status == 200) {                    
            this.$dialog.alert("個人資訊修改成功,請再次確認資料是否正確。", { type: "success", showIcon: false },);             
            this.init();
          } else {
            alert("fail!");
          }
        }).catch(err=>function() {
          alert("fail!");
        });
        }






    }
  }
};


function checkTwID(id){
    //建立字母分數陣列(A~Z)
    var city = new Array(1,10,19,28,37,46,55,64,39,73,82, 2,11,20,48,29,38,47,56,65,74,83,21, 3,12,30)
    id = id.toUpperCase();
    //使用「正規表達式」檢驗格式
    if (id.search(/^[A-Z](1|2)\d{8}$/i) == -1) {
        return false;
    } else {
        //將字串分割為陣列(IE必需這麼做才不會出錯)
        id = id.split('');
        //計算總分
        var total = city[id[0].charCodeAt(0)-65];
        for(var i=1; i<=8; i++){
            total += eval(id[i]) * (9 - i);
        }
        //補上檢查碼(最後一碼)
        total += eval(id[9]);
        //檢查比對碼(餘數應為0);
        return ((total%10 == 0 ));
    }
}
</script>



// WEBPACK FOOTER //
// src/pages/users/personal-default-basic.vue